"use client";

import * as React from "react";
import { Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const features = ["Atlantisholding is a leading technology company specializing in the development and implementation of forward-thinking technology solutions."];
export default function About() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="239597" id="discovery-journey" className="w-full bg-background py-24 px-6">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        {}
        <div ref={textRef} className={`flex flex-col items-start transition-all duration-1000 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-default text-2xl md:text-3xl font-bold text-secondary mb-6 uppercase tracking-wider">
            DISCOVER MORE ABOUT OUR COMPANY
          </h2>
          <p className="font-default text-base text-foreground mb-8 leading-[1.8]">
            We are dedicated to pushing the boundaries of innovation in the global technology landscape. Our mission is to deliver excellence through strategic development and a customer-centric approach that defines the future of the industry.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-1 gap-y-4 gap-x-8 mb-8 w-full">
            {features.map((feature, i) => <div data-index={i} key={i} className="flex items-start gap-3">
                <div className="flex-shrink-0 flex items-center justify-center size-6 rounded-full bg-transparent">
                  <span className="text-secondary font-bold text-lg">{" > "}</span>
                </div>
                <span className="font-default text-base text-foreground leading-[1.8]">KLass Entertainment is a leading technology company specializing in the development and implementation of forward-thinking technology solutions.</span>
              </div>)}
          </div>

          <Button asChild size="lg" className="mt-4 bg-primary hover:bg-primary/90 text-primary-foreground rounded-lg shadow-md transition-all duration-300">
            <Link to="/HomePage">Discover Our Work</Link>
          </Button>
        </div>

        {}
        <div ref={imageRef} className="relative w-full aspect-square md:aspect-[4/3] lg:aspect-square rounded-xl shadow-xl overflow-hidden border-[12px] border-white transition-all duration-1000 delay-200 ease-out opacity-100 translate-x-0 !bg-[url(https://causal-crawfish.10web.cloud/wp-content/uploads/2026/05/casino.jpeg)] !bg-[url(https://klassentertainment.com/wp-content/uploads/2026/05/casino2.jpeg)]">
          
        </div>
      </div>
    </section>;
}